export default __webpack_public_path__ + "static/media/landscape.a348eb1a.svg";